// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"60a0c9d6","291":"2f117307","760":"d8de50ac"}[chunkId] + ".js";
};